import { useState, useRef, useEffect, forwardRef, useImperativeHandle } from "react";
import {
  Box,
  Typography,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Grid2,
  CircularProgress,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import html2canvas from "html2canvas";
import { post, postFormData } from "../apis/apis";
import toastAlert from "./toastAlert";

const TypeText = forwardRef(({
  user_id_user,
  user_email,
  user_first_name,
  user_last_name,
  initialsBox,
  profile,
  onSaveText,
  modalClose,
  modalClosingD,
  receiverSide,
  primaryColorComp,
  hideFooter,
  selectedColor: selectedColorProp,
  onColorChange: onColorChangeProp,
  onProfileSaved,
}, ref) => {
  const [text, setText] = useState(initialsBox ? "Initials" : "Signature");
  const [selectedFont, setSelectedFont] = useState("Brush Script MT");
  const [internalColor, setInternalColor] = useState("#000000");
  const selectedColor = selectedColorProp !== undefined && selectedColorProp !== null ? selectedColorProp : internalColor;
  const handleColorChange = (color) => {
    if (onColorChangeProp) onColorChangeProp(color);
    else setInternalColor(color);
  };
  const handleFontChange = (e) => {
    setSelectedFont(e.target.value);
  };

  const [initialBoxData, setInitialBoxData] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loaderButtonSave, setLoaderButtonSave] = useState(false);
  const primary_color = "rgb(35, 179, 232)";

  // fonts
  const [FontsArray, setFontsArray] = useState([
    "Brush Script MT",
    "Edwardian Script ITC",
    '"Lobster", sans-serif',
    '"Playwrite ES", cursive',
    '"Great Vibes", cursive',
    '"Dancing Script", cursive',
    '"Allura", cursive',
    '"Pacifico", cursive',
  ]);
  // input as text

  const [isEditing, setIsEditing] = useState(true);
  const [inputValue, setInputValue] = useState(
    initialsBox ? "Initials" : "Signature"
  );

  const handleClick = () => {
    setIsEditing(true);
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
    setText(e.target.value);
  };

  const handleBlur = () => {
    setIsEditing(false);
  };
  const [saveAsProfile, setSaveAsProfile] = useState(false);
  const saveAsProfileRef = useRef(saveAsProfile);
  saveAsProfileRef.current = saveAsProfile;

  // start
  //  const [text, setText] = useState("");
  const [fontSize, setFontSize] = useState(40);

  const previewRef = useRef(null);
  const base64toFile = (base64String, filename) => {
    const arr = base64String.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  };
  // const generateImage = () => {
  //   setLoaderButtonSave(true);

  //   setTimeout(() => {
  //     const previewElement = previewRef.current;
  //     const textElement = previewElement.querySelector("p"); // Typography renders as <p>

  //     // 1️⃣ Measure actual text size (precise width/height)
  //     const { width, height } = textElement.getBoundingClientRect();

  //     // 2️⃣ Add extra spacing to prevent clipping
  //     const extraPaddingLeft = 20; // Prevents text from touching left edge
  //     const extraPaddingRight = 20; // Prevents last letter cut-off
  //     const extraPaddingBottom = 10; // Prevents descenders (g, p, q) from being cut
  //     const extraPaddingTop = 10; // Small padding on top

  //     const adjustedWidth = width + extraPaddingLeft + extraPaddingRight;
  //     const adjustedHeight = height + extraPaddingBottom;

  //     // 3️⃣ Resize wrapper to match text exactly
  //     previewElement.style.width = `${adjustedWidth}px`;
  //     previewElement.style.height = `${adjustedHeight}px`;
  //     previewElement.style.paddingLeft = `${extraPaddingLeft}px`; // Adds left spacing
  //     previewElement.style.paddingRight = `${extraPaddingRight}px`; // Adds right spacing
  //     previewElement.style.paddingBottom = `${extraPaddingBottom}px`; // Adds bottom spacing
  //     previewElement.style.paddingTop = `${extraPaddingTop}px`;
  //     previewElement.style.display = "flex";
  //     previewElement.style.justifyContent = "center";
  //     previewElement.style.alignItems = "center";
  //     textElement.style.textAlign = "center";
  //     textElement.style.width = "100%";

  //     // 4️⃣ Capture with updated dimensions
  //     html2canvas(previewElement, {
  //       backgroundColor: null, // Transparent background
  //       scale: 2, // High resolution
  //       width: adjustedWidth,
  //       height: adjustedHeight,
  //       logging: false,
  //     }).then(async (canvas) => {
  //       const imgData = canvas.toDataURL("image/png");

  //       // 5️⃣ Reset styles back to normal (so UI isn't broken after capture)
  //       // previewElement.style.width = "";
  //       // previewElement.style.height = "";
  //       // previewElement.style.paddingLeft = ""; // Reset left padding
  //       // previewElement.style.paddingRight = ""; // Reset right padding
  //       // previewElement.style.paddingBottom = ""; // Reset bottom padding
  //       // previewElement.style.padding = "5px"; // Optional: Restore general padding
  //       previewElement.style.width = "";
  //       previewElement.style.height = "";
  //       previewElement.style.paddingLeft = "";
  //       previewElement.style.paddingRight = "";
  //       previewElement.style.paddingBottom = "";
  //       previewElement.style.paddingTop = "";
  //       previewElement.style.display = "";
  //       previewElement.style.justifyContent = "";
  //       previewElement.style.alignItems = "";
  //       textElement.style.textAlign = "";
  //       textElement.style.width = "";
  //       previewElement.style.padding = "5px"; // Optional: Restore general padding
  //       if (saveAsProfile) {
  //         const filename = "profile_signature.png";
  //         const fileObject = base64toFile(imgData, filename);
  //         // const postData = new FormData();
  //         // postData.append("image", fileObject);
  //         // postData.append("user_id", user_id_user);
  //         const postData = {
  //           image: fileObject,
  //           user_id: user_id_user,
  //         };
  //         const apiData = await postFormData(postData);
  //         if (!apiData.public_url) {
  //           // toastAlert("error", "Error uploading Files");
  //         } else {
  //           const ImageUrl = apiData.public_url;
  //           const TypeCheck = initialsBox ? "profile_initils" : "profile";
  //           const saveSignatureData = {
  //             user_id: user_id_user,
  //             signature_image_url: ImageUrl,
  //             type: TypeCheck,
  //           };
  //           await post("user/AddUserSignaturesToDb", saveSignatureData);
  //           // toastAlert("success", "Signature saved successfully");
  //         }
  //       }
  //       setLoaderButtonSave(false);
  //       onSaveText(imgData, null); // Return final image
  //     });
  //   }, 0);
  // };
  const generateImage = () => {
    setLoaderButtonSave(true);

    const doCapture = () => {
      const previewElement = previewRef.current;
      if (!previewElement) {
        setLoaderButtonSave(false);
        toastAlert("error", "Failed to generate signature image.");
        return;
      }
      const textElement = previewElement.querySelector("p"); // Typography renders as <p>
      if (!textElement) {
        setLoaderButtonSave(false);
        toastAlert("error", "Failed to generate signature image.");
        return;
      }

      // 1️⃣ Measure actual text size (precise width/height)
      const rect = textElement.getBoundingClientRect();
      const width = Math.max(rect.width, 1);
      const height = Math.max(rect.height, 1);

      // 2️⃣ Add extra spacing to prevent clipping
      const extraPaddingLeft = 20; // Prevents text from touching left edge
      const extraPaddingRight = 20; // Prevents last letter cut-off
      const extraPaddingBottom = 10; // Prevents descenders (g, p, q) from being cut
      const extraPaddingTop = 10; // Small padding on top

      const adjustedWidth = width + extraPaddingLeft + extraPaddingRight;
      const adjustedHeight = height + extraPaddingBottom;

      // 3️⃣ Resize wrapper to match text exactly - align text to left
      previewElement.style.width = `${adjustedWidth}px`;
      previewElement.style.height = `${adjustedHeight}px`;
      previewElement.style.paddingLeft = `${extraPaddingLeft}px`; // Adds left spacing
      previewElement.style.paddingRight = `${extraPaddingRight}px`; // Adds right spacing
      previewElement.style.paddingBottom = `${extraPaddingBottom}px`; // Adds bottom spacing
      previewElement.style.paddingTop = `${extraPaddingTop}px`;
      previewElement.style.display = "flex";
      previewElement.style.justifyContent = "flex-start"; // Changed from "center" to "flex-start"
      previewElement.style.alignItems = "center";
      textElement.style.textAlign = "left"; // Changed from "center" to "left"
      textElement.style.width = "100%";

      // 4️⃣ Capture with updated dimensions (white background so saved image is visible in profile list)
      html2canvas(previewElement, {
        backgroundColor: "#ffffff",
        scale: 2, // High resolution
        width: adjustedWidth,
        height: adjustedHeight,
        logging: false,
      }).then(async (canvas) => {
        const imgData = canvas.toDataURL("image/png");

        // 5️⃣ Reset styles back to normal (so UI isn't broken after capture)
        previewElement.style.width = "";
        previewElement.style.height = "";
        previewElement.style.paddingLeft = "";
        previewElement.style.paddingRight = "";
        previewElement.style.paddingBottom = "";
        previewElement.style.paddingTop = "";
        previewElement.style.display = "";
        previewElement.style.justifyContent = "";
        previewElement.style.alignItems = "";
        textElement.style.textAlign = "";
        textElement.style.width = "";
        previewElement.style.padding = "5px"; // Optional: Restore general padding

        if (saveAsProfileRef.current) {
          if (!user_id_user) {
            toastAlert("error", "Cannot save to profile: user not identified. Reload the document and try again.");
          } else {
            try {
              const filename = "profile_signature.png";
              const fileObject = base64toFile(imgData, filename);
              const postData = {
                image: fileObject,
                user_id: user_id_user,
              };
              const apiData = await postFormData(postData);
              if (apiData && apiData.error) {
                toastAlert("error", apiData.message || "Error uploading signature.");
              } else if (apiData && apiData.public_url) {
                const ImageUrl = apiData.public_url;
                const TypeCheck = initialsBox ? "profile_initils" : "profile";
                const saveSignatureData = {
                  user_id: user_id_user,
                  signature_image_url: ImageUrl,
                  type: TypeCheck,
                };
                const saveResult = await post("user/AddUserSignaturesToDb", saveSignatureData);
                if (saveResult && (saveResult.error === true || saveResult.status === false)) {
                  toastAlert("error", saveResult.message || saveResult.error || "Failed to save signature to profile.");
                } else {
                  toastAlert("success", "Signature saved to profile.");
                  onProfileSaved?.();
                }
              } else {
                toastAlert("error", "Upload did not return a valid URL.");
              }
            } catch (err) {
              console.error("Save as profile signature error:", err);
              toastAlert("error", err?.message || "Failed to save signature to profile.");
            }
          }
        }
        setLoaderButtonSave(false);
        onSaveText(imgData, null); // Return final image
      }).catch((err) => {
        console.error("Signature image generation error:", err);
        setLoaderButtonSave(false);
        toastAlert("error", "Failed to generate signature image.");
      });
    };

    // Wait for fonts to load so text signature image uses correct font, then run capture
    const fontReady = typeof document !== "undefined" && document.fonts && document.fonts.ready
      ? document.fonts.ready
      : Promise.resolve();
    fontReady.then(() => setTimeout(doCapture, 0));
  };

  useImperativeHandle(ref, () => ({
    submit: () => generateImage(),
  }), []);

  useEffect(() => {
    console.log("initialsBox");
    console.log(initialsBox);
    if (
      user_first_name &&
      user_first_name !== "null" &&
      user_first_name !== undefined
    ) {
      if (initialsBox) {
        // Set text and inputValue to initials
        const firstInitial = user_first_name[0].toUpperCase();
        // Extract the first letter of the last name and capitalize it
        const lastInitial = user_last_name[0].toUpperCase();
        // Combine the initials
        const initials = `${firstInitial}${lastInitial} `;
        setText(initials);
        setInputValue(initials);
      } else {
        setText(`${user_first_name} ${user_last_name} `);
        setInputValue(`${user_first_name} ${user_last_name}`);
      }
    }
  }, []);
  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        overflow: "hidden",
        flex: 1,
        minHeight: 0,
        position: "relative",
      }}
    >
      {/* Scrollable Content Area */}
      <Box
        sx={{
          flex: 1,
          width: "100%",
          overflow: "auto",
          display: "flex",
          flexDirection: "column",
          minHeight: 0,
          pb: 0,
        }}
      >
        <Grid2 container spacing={0} sx={{ pt: 0, px: 0 }}>
          <Grid2 size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                height: "80px",
                border: "1px solid rgba(0, 0, 0, 0.12)",
                borderRadius: 1,
                display: "flex",
                flexDirection: "column",
                position: "relative",
                borderRadius: 1,
                padding: 2,
              }}
            >
              {/* Header text overlaid on top */}
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "4px 8px",
                  backgroundColor: "rgba(255, 255, 255, 0.9)",
                }}
              >
                <Typography
                  variant="caption"
                  color="text.secondary"
                  sx={{ fontSize: "11px" }}
                >
                  Type Here
                </Typography>
              </Box>

              {/* Input field */}
              {isEditing ? (
                <TextField
                  autoFocus
                  fullWidth
                  value={
                    inputValue === "Signature" || inputValue === "Initials"
                      ? ""
                      : inputValue
                  }
                  onChange={(e) => {
                    const { value } = e.target;
                    const characterLimit = initialsBox ? 5 : 50;
                    const validCharacterRegex = /^[A-Za-z .'-]*$/;

                    if (
                      value.length <= characterLimit &&
                      validCharacterRegex.test(value)
                    ) {
                      handleChange(e);
                    }
                  }}
                  placeholder={initialsBox ? "Initials" : "Signature"}
                  onBlur={() => {
                    // Keep focus if empty, otherwise allow blur
                    if (
                      inputValue === "" ||
                      inputValue === "Signature" ||
                      inputValue === "Initials"
                    ) {
                      // If empty, set the placeholder value back
                      setInputValue(initialsBox ? "Initials" : "Signature");
                    }
                  }}
                  // onBlur={handleBlur}
                  inputProps={{
                    maxLength: initialsBox ? 5 : 20,
                    style: {
                      textAlign: "left",
                      fontSize: "30px",
                      height: "100%",
                      caretColor: "auto",
                      paddingLeft: "5px", // Add left padding for the cursor
                    },
                  }}
                  sx={{
                    height: "100%",
                    "& .MuiOutlinedInput-root": {
                      height: "100%",
                      border: "none",
                      cursor: "text",
                      "& fieldset": { border: "none" },
                      "&:hover fieldset": { border: "none" },
                      "&.Mui-focused fieldset": { border: "none" },
                      // "& fieldset": { border: "none" },
                    },
                    "& .MuiInputBase-input": {
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start", // Change from "center" to "flex-start"
                      cursor: "text",
                      pt: 3, // Add padding top to account for header
                    },
                    cursor: "text",
                  }}
                />
              ) : (
                <Box
                  onClick={handleClick}
                  sx={{
                    height: "100%",
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    cursor: "text",
                    pt: 3, // Add padding top to account for header
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "20px",
                      color: "rgba(0, 0, 0, 0.87)",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      textAlign: "center",
                      width: "100%",
                    }}
                  >
                    {inputValue}
                  </Typography>
                </Box>
              )}
            </Box>
          </Grid2>

          <Grid2 size={{ xs: 12, md: 6 }}>
            <Box
              sx={{
                height: "80px", // Fixed container height
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "1px solid rgba(0, 0, 0, 0.12)",
                borderRadius: 1,
                padding: 2,
              }}
            >
              <Box
                ref={previewRef}
                sx={{
                  display: "inline-block",
                  fontFamily: selectedFont,
                  fontSize: fontSize,
                  color: selectedColor,
                  whiteSpace: "nowrap",
                  overflow: "visible",
                  lineHeight: 1.2,
                  paddingTop: "22px", // This pushes text down
                  alignSelf: "flex-end",
                  maxWidth: "100%",
                }}
              >
                <Typography
                  sx={{
                    fontSize: fontSize,
                    fontFamily: selectedFont,
                    color: selectedColor,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    // maxWidth: {
                    //   xs: text && text.length > 10 ? "150px" : "none", // Show ellipsis on small screens if text > 10 chars
                    //   sm: "none", // No truncation on larger screens
                    // },
                  }}
                >
                  {text}
                </Typography>
              </Box>
            </Box>
          </Grid2>

          <Grid2
            size={12}
            sx={{
              maxHeight: "auto",
              overflowY: "auto",
              padding: 2,
            }}
          >
            <Grid2 container spacing={0} sx={{ padding: 0 }}>
              {FontsArray.map((font, index) => (
                <Grid2
                  size={{ xs: 12, md: 6 }}
                  key={index}
                  sx={{ marginBlock: 0, padding: 0 }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedFont === font}
                        onChange={handleFontChange}
                        value={font}
                        size="small"
                      />
                    }
                    label={
                      <Typography
                        sx={{
                          fontFamily: font,
                          fontSize: "23px",
                          // maxWidth: {
                          //   xs: text && text.length > 10 ? "120px" : "200px", // Smaller width on small screens if text > 10 chars
                          //   sm: "200px", // Normal width on larger screens
                          // },
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }
                        }
                      >
                        {text === "Signature" ||
                          text === "Initials" ||
                          text === ""
                          ? initialsBox
                            ? "Initials"
                            : "Signature"
                          : text}
                      </Typography>
                    }
                  />
                </Grid2>
              ))}
            </Grid2>
          </Grid2>

          {profile === false && (
            <Grid2
              size={12}
              sx={{
                padding: 0,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {!receiverSide && (
                <Box sx={{ minWidth: "fit-content" }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={saveAsProfile}
                        onChange={(e) => setSaveAsProfile(e.target.checked)}
                        size="small"
                        sx={{
                          color: "rgba(0, 0, 0, 0.6)",
                          "&.Mui-checked": {
                            color: "rgb(35, 179, 232)",
                          },
                        }}
                      />
                    }
                    label={
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: { xs: "13px", sm: "14px" },
                          color: "rgba(0, 0, 0, 0.7)",
                        }}
                      >
                        Save as profile {initialsBox ? "initials" : "signature"}
                      </Typography>
                    }
                  />
                </Box>
              )}
            </Grid2>
          )}

        </Grid2>
      </Box>

      {!hideFooter && (
        <Box
          sx={{
            flexShrink: 0,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            gap: 0,
            px: 0,
            py: 0,
            backgroundColor: "#fff",
            borderTop: "1px solid rgba(0, 0, 0, 0.12)",
            position: "sticky",
            bottom: 0,
            zIndex: 10,
          }}
        >
          {/* Color Selection on Left */}
          <Box display="flex" gap={0} alignItems="center">
            {["#000000", "#00008B", "#53bdeb"].map((color) => (
              <Box
                key={color}
                onClick={() => handleColorChange(color)}
                sx={{
                  width: { xs: 36, sm: 40 },
                  height: { xs: 26, sm: 30 },
                  bgcolor: color,
                  borderRadius: 1,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border:
                    selectedColor === color
                      ? `2px solid rgb(0, 145, 255)`
                      : `1px solid ${color}`,
                  cursor: "pointer",
                  transition: "transform 0.2s",
                  "&:hover": {
                    transform: "scale(1.05)",
                  },
                }}
              >
                {selectedColor === color && (
                  <CheckIcon sx={{ color: "#fff", fontSize: { xs: 18, sm: 20 } }} />
                )}
              </Box>
            ))}
          </Box>

          {/* Buttons on Right */}
          <Box display="flex" gap={0}
            sx={{
              marginRight: "20px",
            }}
            alignItems="center">
            <Button
              variant="outlined"
              onClick={modalClosingD}
              sx={{ textTransform: "none" }}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              disabled={loaderButtonSave}
              onClick={generateImage}
              sx={{
                textTransform: "none",
                bgcolor: "rgb(35, 179, 232)",
                boxShadow: "none",
                "&:hover": {
                  bgcolor: "rgb(0, 125, 225)",
                  boxShadow: "none",
                },
              }}
            >
              {loaderButtonSave ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Done"
              )}
            </Button>
          </Box>
        </Box>
      )}
    </Box >
  );
});

TypeText.displayName = "TypeText";

export default TypeText;
